import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/zamzam/web/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "/var/www/zamzam/web/node_modules/nuqs/dist/adapters/next/app.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/var/www/zamzam/web/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["PageLoader"] */ "/var/www/zamzam/web/src/components/common/index.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/zamzam/web/src/providers/BaseProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationsProvider"] */ "/var/www/zamzam/web/src/providers/NotificationsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/zamzam/web/src/providers/SettingsProvider.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/zamzam/web/src/styles/globals.css");
